module.exports = __webpack_public_path__ + "static/media/wechat-qr.d2e6e930.png";